/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Integrations_Zotero_Disconnect_Confirm_TitleInputs */

const en_settings_integrations_zotero_disconnect_confirm_title = /** @type {(inputs: Settings_Integrations_Zotero_Disconnect_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnect Zotero?`)
};

const es_settings_integrations_zotero_disconnect_confirm_title = /** @type {(inputs: Settings_Integrations_Zotero_Disconnect_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Desconectar Zotero?`)
};

/**
* | output |
* | --- |
* | "Disconnect Zotero?" |
*
* @param {Settings_Integrations_Zotero_Disconnect_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_integrations_zotero_disconnect_confirm_title = /** @type {((inputs?: Settings_Integrations_Zotero_Disconnect_Confirm_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Integrations_Zotero_Disconnect_Confirm_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_integrations_zotero_disconnect_confirm_title(inputs)
	return en_settings_integrations_zotero_disconnect_confirm_title(inputs)
});